import React, { Component ,createRef, Fragment} from 'react'
import axios from 'axios'
import { withRouter } from 'react-router'
import Toolbar from './../Toolbar/Toolbar'
import { Tooltip} from "@material-ui/core"
import Dropdown from 'react-dropdown';
import { withStyles } from "@material-ui/core/styles"
import 'react-dropdown/style.css';
import TableOfContents from './../TableOfContents/TableOfContents'
import _uniqueId from 'lodash/uniqueId';
import Directions from './../AttachmentsDisplay/Directions'
import AttachmentRenderer from './../AttachmentsDisplay/AttachmentRenderer'
import StepContent from './../StepContent/StepContent'
import StepActionsToolBar from './../StepActionsToolbar/StepActionsToolbar'
import ModelAnnotationContainter from "../../Author/ModelAnnotation/ModelAnnotation"
import EditStepNameFieldContainer from './../StepActionsToolbar/edit_step_name_field_container'
import PDFDisplay from "./../WiPDFViewer/pdfViewer"
import PublicationPageModal from './../PublicationPage/Modal'
import AttachmentsModal from './../Attachments/Modal'
import AddInfoFormModal from './../InfoPage/Modal'
import EditTagsModal from './../Tags/Modal'
import { imageExtensions, audioExtensions, videoExtensions, documentExtensions} from "../../../../Templates/data"
import { checkNotUndefindeNull, findExtension,isModel,replaceSpanWithTextInString,getRegexSelection } from "../../../../Templates/functions"
import { circleExclamation, AnnotationModelIcon, tocToggleIcon, dotsIcon,closeStepAlertsIcon, countStepAlerts,openStepAlertsIcon,addAttachmentIcon  } from "../../../../Templates/icons"
import { cloneDeep, isEmpty, isEqual, mapKeys } from 'lodash'
import {fetchWorkInstruction, deleteModelAnnotation, deleteHighlight, createHighlight } from '../../../../../util/wi_util'
import { fileName, fileUrl } from '../../../../../util/file_url'
import { online } from '../../../../../util/user_util'
import { getFlatDataFromTree } from 'react-sortable-tree';
import StepAlerts from './../InfoPage/StepAlerts'
import EditTitleForm from './../Toolbar/edit_title_form_container'
import Highlighter from "react-highlight-words";
import temppdf from "./../WiPDFViewer/assets/160.76-EG1.pdf"
import WebViewer from '@pdftron/webviewer'
import EmbeddedWISelect from '../../Author/StepContent/EmbeddedWISelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'

// -------------------------------------------------------------- Tooltip Styles --------------------------------------------------------------//

export const LightTooltip = withStyles((theme) => ({
    tooltip: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow: theme.shadows[1],
            fontSize: "1em",
        },
    }))(Tooltip);

// -------------------------------------------------------------- Component: WIAuthor --------------------------------------------------------------//

class WIAuthorPDF extends Component {
    constructor(props) {
        super()
        this.state = {
            steps: props.workInstruction.steps || [],
            stepsDisplay:[],
            isSavable: true,
            title: "",
            WipGroup:[],
            tempPDF: temppdf,
            selectedStep:null,
            currentAttachments: [],
            attachmentIndex: 0,
            confirmationMessage: "",
            editingContent: false,
            editingPublicationPage: false,
            publicationPage: {},
            editingStepTitle: false,
            editingStepAlerts: false,
            editingtTags: false,
            showingAddInfoForm: false,
            showingAttachments: false,
            embeddedFile: undefined,
            toggleAnnotation: false,
            currentCameraPlacement:[],
            unityContextRef: null,
            selectedStepIsChild: false,
            editingTime:false,
            stepNodePath: [],
            showTOC:true,
            selectedStepDivID:"",
            pathList: [],
            searchString: "",
            stepDivsSearchText: null,
            textSelectedInEditorFlag:false,
            textSelectedInEditor:"",
            annotations:null,
            selectedAnnotation: null,
            existingAnnotationClicked: false,
            AnnotationMode: "view",
            DeleteAnnotationActive:false,
            Pointer:"circle",
            AnnotationArray: [],
            AnnotationCount:0,
            AnnotationText : "",
            modelsLoaded:false,
            AnnotationName: "",
            WebglAnnotationList: [],
            listSent:false,
            displayModelText:false,
            editorRef:null,
            toggleStepDropDown:false,
            isCurrentAttachmentTypeModel:false,
            modelIsLoaded:false,
            textSelectionRange:null,
            annotationHasBeenCreatedPre:false,
            currentStepAttachmentModel:false,
            displayArray:[],
            currentHighlightID: null,
            textToSearch:"",
            currentPDF: null,
            selectedText:"",
            annoList:[],
            viewerDiv: createRef(null),
            PDFAnnotations:null,
            pageNumber:1,
            currentlySelectedPDFAnnotationID: [],
            currentlySelectedPDFAnnotationAttachment:[],
            isRedraw:false,
            combinedTitle: [],
            addingPDFPageWILink: false,
            firstLoaded: false,
            isLibraryOpen: false,
            isLibraryClosing: false,
            previewImages: props.workInstruction.previewImages || [],
            isLiteView: props.isLiteView,
            showEditingWarningModal: false,
            editingWarningMessage: '',
            editingWarningUser: ''
        }
        this.handleModalOpen = this.handleModalOpen.bind(this)
    }
    
    componentDidMount = async () => {

        let stepDivParent = document.getElementById("step-Div-Parent")
        
        // Start heartbeat and fetch WI for editing
        this.startHeartbeat();
        
        fetchWorkInstruction(this.props.wip_ID, !this.props.isLiteView).then(
            res => {
                localStorage.removeItem('persist:wi_author')
                let wi = cloneDeep(res.data)
                this.checkAndShowEditingWarning(wi.editingStatus);
                let firstStep = wi.steps[0]
                //If the work instruction has info items, it will populate currentStepInfoItems with Objects containing keys of categories and a value of items in category. 
                let infoPage = typeof wi.info_page === "string" ? JSON.parse(wi.info_page) : wi.info_page     
                let isModel = this.isAttachmentModel(firstStep,0)
                let currentStepInfoItems = this.buildInfoItems(infoPage, firstStep._id)
                this.setState({
                    currentStepInfoItems,
                    currentAttachments: this.SetAttachmentsBasedOnWipPDF(wi.isPDFViewer,firstStep, wi.PDFViewerHighlights),
                    infoPage: infoPage || {},
                    isReleased: wi.release,
                    previewImage: wi.preview_img || "default-wi-preview-img.jpg",
                    publicationPage: wi.publication_page || {},
                    selectedStep: firstStep,
                    steps: wi.steps,
                    path: firstStep ? [firstStep._id] : [],
                    tags: wi.tags,
                    WipGroup: wi.WipGroup,
                    previewImages: wi.previewImages || [],
                    title: wi.title,
                    isPDFViewer:wi.isPDFViewer,
                    pdfPath: wi.pdfPath,
                    PDFViewerHighlights:wi.PDFViewerHighlights,
                    originalTitle: wi.title,
                    require_info_checks: wi.require_info_checks,
                    workInstruction: wi,
                    stepDivsSearchText: typeof stepDivParent != "undefined" && stepDivParent != null ?  stepDivParent.innerText : "No Text",
                    selectedStepDivID: "div_step_" + firstStep._id,
                    currentStepAttachmentModel: isModel,
                }, () => {
                        this.setState({ loaded: true})
                        this.getSetWipPDF()
                        this.createAnnotationArray()
                        
                })
        var pageListener = document.getElementById("wi-author-page")
        {pageListener ? pageListener.addEventListener("click", this.handleClicks) : console.log("unable to add listener to wi author")}
        this.setEventListener();
        this.setUnityCameraEventListener();
            }).catch((err)=>{
                alert("An error occured while trying to open this WI. Please contact an administrator for assisstance.")
                console.error(err)
            })
    }
// -------------------------------------------------------------- Component Lifecycle: componentDidUpdate --------------------------------------------------------------//

    componentDidUpdate(prevProps) {
        if(!isEqual(this.state.selectedStep, prevProps.selectedStep)) 
        {
            if(checkNotUndefindeNull(this.state.unityContextRef)) 
            {this.setUnityCameraEventListener();}

            if(this.state.selectedStep != null){
                let el = document.getElementById("div_step_" + this.state.selectedStep._id)
                if(el != null){
                    el.focus();
                }
            }
        }
    }  
// -------------------------------------------------------------- Component Lifecycle: componentWillUnmount --------------------------------------------------------------//

    componentWillUnmount = () => {
       try {
       } catch (e) {}
       this.unsetEventListener();
       this.stopHeartbeat();
    }   

    // -------------------------------------------------------------- Editing Status Warning System --------------------------------------------------------------//
    
    startHeartbeat = () => {
        if (this.props.isLiteView) {
            return;
        }
        this.heartbeatInterval = setInterval(() => {
            if (this.props.wip_ID) {
                axios.post(`/api/wip/${this.props.wip_ID}/heartbeat`)

                    .catch((error) => console.error(`[PDF WI ${this.props.wip_ID}] Heartbeat failed:`, error.response?.status, error.response?.data));
            }
        }, 10000); // 10 seconds for testing
    }

    stopHeartbeat = () => {
        if (this.props.isLiteView) {
            return;
        }
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        }
        if (this.props.wip_ID) {
            axios.post(`/api/wip/${this.props.wip_ID}/stop-editing`)
                .catch((error) => console.log('Stop editing signal failed:', error));
        }
    }

    checkAndShowEditingWarning = (editingStatus) => {
        // Skip editing warning for Lite views (read-only/nested WIs)
        if (this.props.isLiteView) {
            return;
        }
        
        if (editingStatus && editingStatus.isActivelyEditing && editingStatus.editing_user !== this.props.user?.username) {
            const secondsSinceStarted = editingStatus.secondsSinceStartedEditing || 0;
            const timeEditing = secondsSinceStarted < 60 ? 
                `${secondsSinceStarted} seconds` : 
                `${Math.floor(secondsSinceStarted / 60)} minutes`;
                
            this.setState({
                showEditingWarningModal: true,
                editingWarningMessage: `"${editingStatus.editing_user}" has been editing this Work Instruction for ${timeEditing}. Editing simultaneously may cause conflicts and data loss.`,
                editingWarningUser: editingStatus.editing_user
            });
        }
    }
    
    handleReturnToList = () => {
        // Navigate back to the WI list
        this.props.history.push('/dashboard/work%20instructions%20parent');
    }
    
    handleContinueEditing = () => {
        // Close the modal and continue with editing
        this.setState({
            showEditingWarningModal: false,
            editingWarningMessage: '',
            editingWarningUser: ''
        });
    }

// -------------------------------------------------------------- Set Attachments Based on Work Instruction PDF --------------------------------------------------------------//

    SetAttachmentsBasedOnWipPDF=(isPDFViewer,firstStep,PDFViewerHighlights)=>{
        if(isPDFViewer)
        {
            return []
        }
        if(firstStep)
        {
         return firstStep.attachments
        }
        return []
    }
// -------------------------------------------------------------- Add wi link to WipGroup --------------------------------------------------------------//
    
    addWILink=(wi)=>{
        let WipGroup = cloneDeep(this.state.WipGroup)
        WipGroup.push(wi)
        this.setState({WipGroup},()=>{
            this.saveWorkInstruction();
        })
    } 

    // -------------------------------------------------------------- Creates an array of annotations for the WebGL viewer. --------------------------------------------------------------//

    createAnnotationArray =() =>{
        let WebglList = []
        if(this.state.selectedStep != null){
            let attachments = this.state.selectedStep.attachments                
            const currentAttachment = attachments[this.state.attachmentIndex || 0]       
            if (true){
                if(checkNotUndefindeNull(currentAttachment) && checkNotUndefindeNull(currentAttachment.annotations)){
                        currentAttachment.annotations.forEach(annotation => {          
                        let state = ""
                        if(annotation.state){
                            state = JSON.parse(annotation.state)
                        }else{
                            state = {name:"Annotation"}
                        }
                        WebglList.push(JSON.parse(state.orgCameraData))                                  
                        })
                    }              
            }       
        }
        this.setState({ WebglAnnotationList : WebglList})
    }

    // -------------------------------------------------------------- Checks step content for temporary highlights. --------------------------------------------------------------//
    checkStepContentForTempHighlight=(steps)=>{
        let spans = document.getElementsByClassName("TempHighlight")
        if(spans.length > 0){
            let test =  this.findAllByKey(steps)
        }
        return steps 
    } 
// -------------------------------------------------------------- remove wi link to WipGroup --------------------------------------------------------------//
    
    deleteWILink=(wi)=>{
        console.log('[deleteWILink] Starting WI link deletion process')
        console.log('[deleteWILink] WI object:', wi)
        console.log('[deleteWILink] Current WipGroup before deletion:', cloneDeep(this.state.WipGroup))
        
        this.removeWILinkHighlight(wi.wiID)
        let WipGroup = cloneDeep(this.state.WipGroup)
        for(let w in WipGroup){
            if(WipGroup[w].wip_ID == wi.wiID){
                console.log('[deleteWILink] Marking WI as deleted:', WipGroup[w])
                WipGroup[w].del = true
            }
        }
        console.log('[deleteWILink] WipGroup after marking as deleted:', WipGroup)
        
        this.setState({WipGroup},()=>{
            console.log('[deleteWILink] State updated, calling saveWorkInstruction')
             this.saveWorkInstruction();
        })
    }
// -------------------------------------------------------------- remove annotation to WipGroup --------------------------------------------------------------//
    
    deleteAnnotation=(wi)=>{
        this.removeWILinkHighlight(wi.wiID)
        let Wg = cloneDeep(this.state.WipGroup)
        let WipGroup = Wg.filter(w=> w.wip_ID !== wi.wiID)   
        this.setState({WipGroup},()=>{
             this.saveWorkInstruction();
        })
    }
// -------------------------------------------------------------- will remoce the WI highlioght from the text --------------------------------------------------------------//
    
    removeWILinkHighlight=(wi)=>{
        console.log('[removeWILinkHighlight] Starting WI link highlight removal')
        console.log('[removeWILinkHighlight] WI ID to remove:', wi)
        console.log('[removeWILinkHighlight] Current selectedStep:', this.state.selectedStep)
        
        let content = this.state.selectedStep.content
        console.log('[removeWILinkHighlight] Step content before removal:', content)
        
        let regExp = new RegExp('\\&lt;WI,(.*?),(.*?),(.*?).&gt;','g')
        let matchesAll = [...content.matchAll(regExp)]
        console.log('[removeWILinkHighlight] Found WI link matches:', matchesAll)
        
        if(null != matchesAll && matchesAll.length > 0){
            for(let i = 0; i < matchesAll.length; i++){
                console.log('[removeWILinkHighlight] Checking match:', matchesAll[i])
                if(matchesAll[i][2] === wi){
                    console.log('[removeWILinkHighlight] Found matching WI to remove:', matchesAll[i][0])
                    let newContent = content.replace(matchesAll[i][0],"")
                    console.log('[removeWILinkHighlight] New content after removal:', newContent)
                    
                    let selectedStep = this.state.selectedStep
                    if (selectedStep) {
                        selectedStep.content = newContent
                        let steps = this.updateStep(selectedStep)
                        this.updateSteps(steps, selectedStep);
                        this.createStepsDisplay();      
                        console.log('[removeWILinkHighlight] Step content updated and display refreshed')
                    }
                }
            }
        } else {
            console.log('[removeWILinkHighlight] No WI link matches found in content')
        }
    }
     //TODO: chqnge code to work with highlights
    checkIfAttachmentHasAnnotationArray =() => {
        let selectedStepClone = cloneDeep(this.state.selectedStep)
        if(checkNotUndefindeNull(selectedStepClone)){
            let attachments = selectedStepClone.attachments  
            const currentAttachment = attachments[this.state.attachmentIndex || 0]  
            
            if(attachments.length > 0 && typeof currentAttachment.annotations != "undefined" && currentAttachment.annotations != null && currentAttachment.annotations.length > 0){
                console.log(typeof currentAttachment.annotations)
                currentAttachment.annotations = [];
                attachments[this.state.attachmentIndex || 0] = currentAttachment
                selectedStepClone.attachments = attachments
                let steps = this.updateStep(selectedStepClone)
                this.updateSteps(steps, selectedStepClone);
            }
        }
    }
// -------------------------------------------------------------- Set Unity Camera Event Listener --------------------------------------------------------------//

    setUnityCameraEventListener =() =>{
        if (this.state.unityContextRef != null){
            this.state.unityContextRef.on("modelsLoaded", () => {
                this.setState({modelsLoaded: true});
                this.sendlist()
            })
            this.state.unityContextRef.on("storeCameraData", (cameraData) => {            
                let pasredCameraData = JSON.parse(cameraData);   
                let SelectedAnnotationClone = cloneDeep(this.state.selectedAnnotation);
                if(SelectedAnnotationClone != null){
                    let state = JSON.parse(SelectedAnnotationClone.state) 
                    SelectedAnnotationClone.camera_position = this.convertCameraData(pasredCameraData.position);
                    SelectedAnnotationClone.camera_rotation = this.convertCameraData(pasredCameraData.rotation);//orgCameraData
                    state.orgCameraData = cameraData
                    SelectedAnnotationClone.state = JSON.stringify(state)
                    this.setState({selectedAnnotation : SelectedAnnotationClone});
                }        
            });
            this.state.unityContextRef.on("storeClickedAnnotation", (AnnotationData) => {
            })
            this.state.unityContextRef.on("storeCreatedAnnotation", (AnnotationData) => {
                this.addAnnotation(AnnotationData); 
            })
            this.state.unityContextRef.on("storeDeletedAnnotation", (AnnotationData) => {
                let data = JSON.parse(AnnotationData)
                this.deleteAnnotationFromWebgl(data.id)   
            })
        }
    }
// -------------------------------------------------------------- Converts camera data into a string representation. --------------------------------------------------------------//

    convertCameraData =(data) =>{
        let cameraDataString = data.x.toString() + ", " + data.y.toString() + ", " + data.z.toString()
        return cameraDataString
    }
// -------------------------------------------------------------- Converts rotation data into a string representation. --------------------------------------------------------------//

    convertRotationData =(data) =>{
        let cameraDataString = data.w.toString() + ", " + data.x.toString() + ", " + data.y.toString() + ", " + data.z.toString()
        return cameraDataString
    }
// -------------------------------------------------------------- Unsets an event listener and updates the element's position if needed. --------------------------------------------------------------//

    unsetEventListener =() =>{
        let display = document.getElementById("webGL-window")
        {display? display.removeEventListener("click",this.updateCamerandMousePosition): console.log("Unable to unset click listener for webgl")}
        {display? display.style.removeProperty("position"): console.log("Unable to remove positon to absolute for webgl")}
        if (this.state.unityContextRef != null){
        }
    }
// -------------------------------------------------------------- Sets an event listener and updates the element's position if needed. --------------------------------------------------------------//

    setEventListener =() =>{
        let display = document.getElementById("webGL-window")
        {display? display.addEventListener("click",this.updateCamerandMousePosition): console.log("Unable to set click listener for webgl")}
        {display? display.style.setProperty("position","absolute"): console.log("Unable to set positon to absolute for webgl")}  
    }
// -------------------------------------------------------------- Sets the selected annotation, updates the state, and sends data to the model viewer. --------------------------------------------------------------//

    setSelectedAnnotation = (annotation ,id) =>{
        this.removeSelectedAnnotationClass();
        let newSelectedDiv = document.getElementById(id)
        if(typeof newSelectedDiv != "undefined" && newSelectedDiv != null){
            newSelectedDiv.classList.add("selectedAnnotation")
        }
        let state = JSON.parse(annotation.state)
        this.setState(
            {AnnotationMode : "view", 
            selectedAnnotation: annotation, 
            DeleteAnnotationActive: true, 
            Pointer: annotation.pointer , 
            AnnotationText: annotation.message || "", AnnotationName: state.name,
            existingAnnotationClicked: true
            })
            this.sendAnnotationToWebgl(annotation.Anno_id)
            this.clickOnAnnotation(annotation.Anno_id);
    }
// -------------------------------------------------------------- Sends an annotation to the WebGL viewer. --------------------------------------------------------------//

    sendAnnotationToWebgl=(id)=>{
        if(checkNotUndefindeNull(this.state.unityContextRef)){
            this.state.unityContextRef.send("Manager","ShowAnnotation",(id))
            this.state.unityContextRef.send("Manager","LookAtAnnotation",(id))
        }
    }
// -------------------------------------------------------------- Creates a new annotation. --------------------------------------------------------------//

    createAnnotation =(highLightedText)=>{
        if(this.state.isLibraryOpen){
            return;
        }
        let randString = this.makeid(15)
        let id = _uniqueId(`${randString}-`)
        let name = highLightedText
        let displayWidth = document.getElementById("webGL-window").clientWidth;
        let displayHeight = document.getElementById("webGL-window").clientHeight;
        let NewAnnotation ={
            Anno_id : id,
            background_color: "#ffffff",
            state: JSON.stringify({name:name,canvasWidth: displayWidth, canvasHeight:displayHeight, orgCameraData:{} }),
            message: highLightedText? highLightedText : "",
            camera_position: "",
            camera_rotation: "", 
            x: 0,
            y: 0,
            pointer: "circle"
        }
        this.removeSelectedAnnotationClass();
        this.setState({AnnotationMode : "new",selectedAnnotation: NewAnnotation, Pointer: "circle", AnnotationText:"", AnnotationName: name,existingAnnotationClicked: false});
    
    }
// -------------------------------------------------------------- Adds an annotation. --------------------------------------------------------------//
    //edited stepID and highlightID
    addAnnotation = (data) => {
        if(this.state.isLibraryOpen){
            return;
        }
        let webGLWindow = document.getElementById("webGL-window");
        let anno_array = cloneDeep(this.state.AnnotationArray)
        let name = this.state.textSelectedInEditor
        let displayWidth = webGLWindow.clientWidth;
        let displayHeight = webGLWindow.clientHeight;
        let parsedData = JSON.parse(data)
        let newAnnotation =  {
             wipID:this.state.workInstruction._id,
             StepID: null,
             HighlightID:this.state.currentlySelectedPDFAnnotationID,
             AttachmentID:this.state.currentAttachments[this.state.attachmentIndex]._id,
             Anno_id : parsedData.id,
             background_color: "#ffffff",
             state: JSON.stringify({name:name,canvasWidth: displayWidth, positon:this.convertCameraData(parsedData.position), canvasHeight:displayHeight, orgCameraData:data, scale:parsedData.scale }),
             message: this.state.textSelectedInEditor,
             camera_position: this.convertCameraData(parsedData.cameraPosition),
             camera_rotation: this.convertRotationData(parsedData.cameraRotation), 
             x: 0,
             y: 0,
             pointer: "circle"}
        this.setState({AnnotationMode : "new",
        selectedAnnotation: newAnnotation, 
        Pointer: "circle", 
        AnnotationText:parsedData.text, 
        AnnotationName: name,
        existingAnnotationClicked: false, 
        annotationHasBeenCreatedPre:true});
    }
// -------------------------------------------------------------- Handles clicking on an annotation. --------------------------------------------------------------//

    clickOnAnnotation =(id) =>{
        if(this.state.isLibraryOpen){
            return;
        }
        if(!this.state.listSent){
            this.sendlist();
            this.setState({listSent:true})
            setTimeout(()=>{
                if(checkNotUndefindeNull(this.state.unityContextRef)){
                    this.state.unityContextRef.send("Manager","ShowAnnotation",id)
                    this.state.unityContextRef.send("Manager","LookAtAnnotation",id)
                }
            },100)
        }
        else{
            if(checkNotUndefindeNull(this.state.unityContextRef)){
                this.state.unityContextRef.send("Manager","ShowAnnotation",id)
                this.state.unityContextRef.send("Manager","LookAtAnnotation",id)
            }
        }      
    }
// -------------------------------------------------------------- Sends a list of annotations to the WebGL viewer. --------------------------------------------------------------//

    sendlist =() =>{
        if(checkNotUndefindeNull(this.state.unityContextRef)){
            this.state.unityContextRef.send("Manager","SetAnnotations",JSON.stringify({annotationDatas:this.state.WebglAnnotationList}))
        }
    }
// -------------------------------------------------------------- Passer function that sets title in Children Components --------------------------------------------------------------//

    setTitle = (newTitle) => {
        this.setState({ title: newTitle });
    }


// -------------------------------------------------------------- Builds a dictionary of info items for the given step. --------------------------------------------------------------//

    buildInfoItems = (infoPage, stepId) => {
        let currentStepInfoItems = {}
        if (!isEmpty(infoPage)) {
            for (const [infoItem, infoObject] of Object.entries(infoPage)) {
                if (infoObject.steps.includes(stepId)) {
                    if (!currentStepInfoItems[infoObject.category]) {
                        currentStepInfoItems[infoObject.category] = []
                    }
                    currentStepInfoItems[infoObject.category].push(infoItem)
                }
            }
        }
        return currentStepInfoItems
    }
// -------------------------------------------------------------- Closes the confirmation message. --------------------------------------------------------------//

    closeConfirmation = (e) => {
        this.setState({ confirmationMessage: "" });
    }
// -------------------------------------------------------------- Handles opening an embedded attachment. --------------------------------------------------------------//

    openEmbeddedAttachment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let fileName = e.target.innerText
        this.setState({ embeddedFile: fileName })
    }
// -------------------------------------------------------------- Initiates preview of the work instruction. --------------------------------------------------------------//

    handleModalOpen = () => {
        this.setState({isLibraryOpen: true})
    }

    backToWIList=()=>{
        let url = "/dashboard/work instructions parent"
        this.props.history.push(url)
    }
// -------------------------------------------------------------- Renders different modals based on component state. --------------------------------------------------------------//

    renderModal = () => {
        if (this.state.embeddedFile) {
            let embeddedFile = this.state.embeddedFile
            let files = this.state.currentAttachments.filter(attachment => attachment.path === embeddedFile)
            let fileExtension = findExtension(embeddedFile)
            let fileExtensions
            if (audioExtensions.includes(fileExtension)) {
                fileExtensions = audioExtensions
            } else if (videoExtensions.includes(fileExtension)) {
                fileExtensions = videoExtensions
            } else if (imageExtensions.includes(fileExtension)) {
                fileExtensions = imageExtensions
            } else {
                fileExtensions = documentExtensions[0]
            }
               
            let isImageType = isEqual(fileExtensions, imageExtensions)
            return <AttachmentsModal 
                callingComponent={"Work Instruction Author File Viewer"}
                isLibraryOpen={this.state.isLibraryOpen}
                handleModalOpen={this.handleModalOpen}
                workInstructionId={this.props.match.params.WIID}
                modalTitle={isImageType ? "Images" : "File List"}
                closeModal={() => {
                    this.setState({ embeddedFile: "", isLibraryOpen: false })}
                }
                fileTypes={fileExtensions}
                files={files}
                selectedStep={this.state.selectedStep}
                updateStep={this.updateStep}
                updateSteps={this.updateSteps}
            />
        } else if (this.state.showingAddInfoForm) {
            return <AddInfoFormModal
                modalTitle={<div className="flex-centered" style={{marginLeft: '1em'}}>
                    {circleExclamation}
                    <p style={{marginLeft: ".5em"}}>All Alerts</p>
                    </div>}
                callingComponent={"Work Instruction Author Add Info"}
                closeModal={this.toggleAllAlertsPage}
                updateInfoPage={this.updateInfoPage}
                infoPage={this.state.infoPage}
                steps={this.state.steps}
                toggleGlobalItem={this.toggleGlobalItem}
                addCategoryToInfoItem={this.saddCategoryToInfoItem}
                editItemName={this.editItemName}
                addItemToInfoPage={this.addItemToInfoPage}
                runInfoPageCleanUp={this.runInfoPageCleanUp}
                addItemToStep={this.addItemToStep} />
        } else if (this.state.showingAttachments) {
            let attachmentForLib = this.setCurrentAttachmentsforLibrary()
            return <AttachmentsModal
                modalTitle={"Attachments Library"}
                callingComponent={"Work Instruction Author Attachments Library"}
                closeModal={() => {
                    this.toggleAttachments()
                    this.setState({ embeddedFile: "", isLibraryOpen: false })}
                }
                WIPID = {this.state.workInstruction._id}
                HighlightID ={this.state.currentHighlightID}
                currentAttachments={attachmentForLib}//{this.state.selectedStep ? mapKeys(this.state.selectedStep.attachments, "_id") : {}}
                previewAttachment={this.previewAttachment}
                selectedStep={this.state.selectedStep}
                isPDFViewer={this.state.isPDFViewer}
                isLibraryOpen={this.state.isLibraryOpen}
                isLibraryClosing={this.state.isLibraryClosing}
                handleModalOpen={this.handleModalOpen}
                currentlySelectedPDFAnnotationID={this.state.currentlySelectedPDFAnnotationID}
                currentlySelectedPDFAnnotationAttachment={this.state.currentlySelectedPDFAnnotationAttachment}
                saveNewPDFHighLightAttachments={this.saveNewPDFHighLightAttachments}
                steps={this.state.steps}
                updateStep={this.updateStep}
                updateSteps={this.updateSteps}

            />
        } else if (this.state.editingPublicationPage) {
            return <PublicationPageModal
                backToWIList = {this.backToWIList}
                previewImage={this.state.previewImage}
                setTitle={this.setTitle}
                setPreviewImage={(path) => this.setState({ previewImage: path, isSavable: true })}
                setPreviewImages={(paths) => this.setState({ previewImages: paths, isSavable: true })}
                setInfoChecksRequirement={(bool) => this.setState({ require_info_checks: bool, isSavable: true })}
                infoChecksRequirement={this.state.require_info_checks}
                steps={this.state.steps}
                // PUBLICATION PAGE IS PAYLOAD FROM PublicationPage component
                updatePublicationPage={(publicationPage) => this.setState({ publicationPage, isSavable: true })}
                saveWorkInstruction={this.saveWorkInstruction}
                publicationPage={this.state.publicationPage}
                toggleRelease={this.toggleRelease}
                WIPID={this.state.workInstruction._id}
                workInstruction={this.state.workInstruction}
                title={this.state.title}
                modalTitle={"Publication Page"}
                callingComponent={"Work Instruction Author Publication Page"}
                closeModal={this.togglePublicationPage}
            />
        } else if (this.state.editingTags) {
            return <EditTagsModal
                workInstructionId={this.state.workInstruction._id}
                currentWorkInstructionTags={this.state.tags}
                modalTitle={"Edit Tags Form"}
                callingComponent={"Work Instruction Author Tags Edit"}
                closeModal={this.toggleEditTags}
                updateTags={(tags) => this.setState({ isSavable: true, editingTags: false, tags })} />
        } 
     else if (this.state.addingPDFPageWILink && this.state.isPDFViewer ){
        return <EmbeddedWISelect
                    attachWIButton={this.addNewWILinkAnnotation}
                    SetToClose={()=>this.setWILinkModal(false)}
                    openNewTab={this.openNewTab}
               >
               </EmbeddedWISelect>
    }
        else {
            return
        }
    }
// -------------------------------------------------------------- Determines the current attachments for the library view. --------------------------------------------------------------//
    //edited
    setCurrentAttachmentsforLibrary=()=>{ 
            if(this.state.currentAttachments){
              return  mapKeys(this.state.currentAttachments, "_id") 
            }  
        return {} 
    }
// -------------------------------------------------------------- Checks if two quads for annotations are the same. --------------------------------------------------------------//

    isHighlightTheSame=(quad1,quad2)=>{ 
        if (quad1.x1 == quad2.x1 && quad1.x2 == quad2.x2 && quad1.x3 == quad2.x3 && quad1.x4 == quad2.x4 &&
            quad1.y1 == quad2.y1 && quad1.y2 == quad2.y2 && quad1.y3 == quad2.y3 && quad1.y4 == quad2.y4){
                return true;
            }
            return false;
    }
// -------------------------------------------------------------- Removes an annotation from the WebGL viewer. --------------------------------------------------------------//

    removeAnnotationFromScreen=(annotationID)=>{
        if(checkNotUndefindeNull(this.state.unityContextRef)){
            this.state.unityContextRef.send("Manager","SetRemoveAnnotation",annotationID)
        }
    }
// -------------------------------------------------------------- Saves new PDF highlight attachments. --------------------------------------------------------------//

    saveNewPDFHighLightAttachments=(attachments)=>{
     let clone =  cloneDeep(this.state.annoList ) 
     clone.forEach(anno=>{
         if(this.isHighlightTheSame(anno.quads[0],this.state.currentlySelectedPDFAnnotationID))
         {
             anno.attachments = attachments
         }
     })
     // Update both annoList AND PDFViewerHighlights to keep them in sync
     this.setState({
         annoList:clone,
         PDFViewerHighlights: clone,
         currentAttachments:attachments,
         attachmentIndex:0, 
         attcurrentlySelectedPDFAnnotationAttachment:attachments,
         isSavable:true
     })
    }
// -------------------------------------------------------------- Initiates an auto-save of the work instruction. --------------------------------------------------------------//

// -------------------------------------------------------------- Saves work instruction data, handles release and updates. --------------------------------------------------------------//
    updateStepOrder = (treeData) => {
        const stepLoop = (steps) => {
            for (let i = 0; i < steps.length; i++) {
                steps[i].order = i + 1;
                if (steps[i].children.length > 0) {
                    stepLoop(steps[i].children)
                }
            }
        }

        for (let i = 0; i < treeData.length; i++) {
            treeData[i].order = i + 1;
            if (treeData[i].children.length > 0) {
                stepLoop(treeData[i].children)
            }
        }

        return treeData
    }
    saveWorkInstruction = (togglingRelease, nextReleaseState, publicationPagePayload, callback) => {
        let workInstruction = cloneDeep(this.state.workInstruction);
        let checkedSteps = cloneDeep(this.state.steps);
        checkedSteps = this.checkStepContentForTempHighlight(checkedSteps);

        workInstruction.release = false // Default value, might be overridden below
        workInstruction.isAssignable = false
        workInstruction.title = this.state.title; // Use state title (updated by setTitle)
        workInstruction.steps = this.updateStepOrder(checkedSteps);
        workInstruction.WipGroup = this.state.WipGroup;
        workInstruction.PDFViewerHighlights = this.state.annoList;
        workInstruction.preview_img = this.state.previewImage; // Use state previewImage
        workInstruction.previewImages = this.state.previewImages; // Assuming this is managed correctly
        workInstruction.workStatus = "Not Started";
        workInstruction.info_page = JSON.stringify(this.state.infoPage);
        workInstruction.tags = this.state.tags;
        // If publicationPagePayload is provided, use it. Otherwise, use existing state.
        workInstruction.publication_page = publicationPagePayload ? publicationPagePayload : this.state.publicationPage;
        workInstruction.require_info_checks = this.state.require_info_checks; // Use state require_info_checks

        if (togglingRelease) {
            workInstruction.release = nextReleaseState;
        } else {
            // If just saving, ensure release state isn't accidentally changed
            workInstruction.release = this.state.isReleased;
        }


        this.props.updateWorkInstruction(workInstruction).then((data) => {
            const confirmationMessage = togglingRelease
                ? (nextReleaseState
                    ? `Your Work Instruction Has Been Released. It may take a few minutes before it appears in the Assignments Page.`
                    : 'Your Work Instruction Has Been Unreleased.')
                : "Your Work Instruction has been saved.";

            // Clear first to retrigger banner animation and guarantee visibility on repeat saves
            this.setState({ confirmationMessage: "" }, () => {
                setTimeout(() => {
                    this.setState({
                        confirmationMessage,
                        isReleased: togglingRelease ? nextReleaseState : this.state.isReleased,
                        isSavable: false,
                        ...(publicationPagePayload && { publicationPage: publicationPagePayload })
                    }, () => {
                        if (callback) {
                            callback();
                        } else {
                            setTimeout(this.closeConfirmation, 10000);
                        }
                        if (togglingRelease && nextReleaseState) {
                            setTimeout(() => this.backToWIList(), 100);
                        }
                    });
                }, 0);
            });

        }).catch((err) => {
            console.log(err);
            // Handle error - maybe show a message?
            // window.alert("Failed to save/release work instruction.");
            //  if (callback) {
            //     callback(err); // Pass error to callback if needed
            // }
        });
    }
// -------------------------------------------------------------- Stores color information for an attachment. --------------------------------------------------------------//
   // todo: maybe edit this
    storeColor = (color) => {
        let selectedStep = this.state.selectedStep
        let currentAttachments = this.state.currentAttachments
        currentAttachments[this.state.attachmentIndex].background_color = color
        selectedStep.attachments = currentAttachments
        let steps = this.updateStep(selectedStep)
        this.updateSteps(steps, selectedStep)
    }
// -------------------------------------------------------------- Handles the submission of edited title data. --------------------------------------------------------------//

    submitTitleEdit = (title) => {
        this.setState({
            editingTitle: false,
            title,
        })
    }
// -------------------------------------------------------------- Toggles the display of the "Add Info" form. --------------------------------------------------------------//

    toggleAllAlertsPage = (e) => {
        this.setState(prevState => ({ showingAddInfoForm: !prevState.showingAddInfoForm }));
    }
// -------------------------------------------------------------- Toggles the display of attachments. --------------------------------------------------------------//

    toggleAttachments = (e) => {
        if (this.state.showingAttachments) {
            // Closing: trigger animation first
            this.setState({ isLibraryClosing: true }, () => {
                setTimeout(() => {
                    this.setState({ 
                        showingAttachments: false, 
                        isLibraryClosing: false,
                        isLibraryOpen: false
                    }, () => {
                        let node = document.getElementsByClassName("selected-container")
                        if (node.length > 0) {
                            node[0].click();
                        }
                    });
                }, 250); // Match ChatButton animation duration
            });
        } else {
            // Opening: set states
            this.setState({ showingAttachments: true });
        }
    }
// -------------------------------------------------------------- Toggles the editing state for tags. --------------------------------------------------------------//

    toggleEditTags = (e) => {
        return this.setState(prevState => ({ editingTags: !prevState.editingTags }));
    }
// -------------------------------------------------------------- Toggles the publication page with or without release. --------------------------------------------------------------//

    togglePublicationPage = (e, withRelease) => {
        return withRelease === true ?
            this.setState(prevState => ({ editingPublicationPage: !prevState.editingPublicationPage, confirmationMessage: "Your Work Instruction is being finalized" }), () => setTimeout(this.toggleRelease, 4000)): 
            this.setState(prevState => ({ editingPublicationPage: !prevState.editingPublicationPage }))
    }
// -------------------------------------------------------------- Toggles the work instruction release state. --------------------------------------------------------------//

    toggleRelease = () => {
        return this.saveWorkInstruction(true, !this.state.isReleased);
    }

    getInfoPage=()=>{
        return this.state.infoPage
    }

// -------------------------------------------------------------- Updates the toggleAnnotation state. --------------------------------------------------------------//

    updateToggleAnnotation = (toggleAnnotation) => {
        this.setState({toggleAnnotation: toggleAnnotation, editingStepAlerts: false});
    }
// -------------------------------------------------------------- Updates the Unity context and model loading status. --------------------------------------------------------------//

    updateUnityContext =(context,modelsLoaded) =>{
        if(null != context){
        }

        this.setState({unityContextRef: context, modelsLoaded})
    }
// -------------------------------------------------------------- Generates a random ID. --------------------------------------------------------------//
    //todo: maybe delete this
    makeid = (length)=> {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

// -------------------------------------------------------------- Shows an annotation. --------------------------------------------------------------//

    showAnnotation=(event)=>{
        event.stopPropagation()
        let index = event.target.id.split("~~~")[1]
        let annotationID = event.target.id.split("~~~")[0]
        if (this.state.selectedStepDivID !== event.srcElement.offsetParent.parentElement.parentElement.id){
            event.srcElement.offsetParent.parentElement.parentElement.click();
            let id = ""
            this.setState({attachmentIndex:index},()=>{
                
                this.sendAnnotationToWebgl(annotationID)
            })


            }
            else if(this.state.attachmentIndex !== index){
                this.setState({attachmentIndex:index},()=>{
                
                    this.sendAnnotationToWebgl(annotationID)
                })
            }
            else{
                this.sendAnnotationToWebgl(annotationID)
            }

            
        
    }
// -------------------------------------------------------------- Opens WI link in new tab. --------------------------------------------------------------//

    showWI = async (event) => {
        event.stopPropagation()
        const wiTitle = event.target?.innerText || ''
        const wiId = event.target?.id
        if (!wiId) return

        try {
            const isOnline = await online()
            if (!isOnline) {
                alert('Nested Work Instructions are not available offline. Connect to the network to open.')
                return
            }
            await fetchWorkInstruction(wiId)
            this.props.addTab(wiTitle, wiId)
        } catch (err) {
            console.error('Failed to fetch WI info for nested tab:', err)
            const status = err?.response?.status
            const msg = err?.response?.data?.message || ''
            if (status === 404 || status === 410 || /deleted|not found/i.test(msg)) {
                alert('This Work Instruction has been deleted.')
            } else {
                alert('Failed to load the nested Work Instruction. Please try again.')
            }
        }
    }
// -------------------------------------------------------------- delete wi link. --------------------------------------------------------------//

    deleteWI=(event)=>{
        event.stopPropagation()
        this.deleteWILink({wiID:event.target.id.split("_")[1]})
        
    }
// -------------------------------------------------------------- Gets the path for a given randString. --------------------------------------------------------------//

    getPath=(randString)=>{
        let link = this.state.pathLink.filter(l => l.id == randString)
        return link.path
    }
// -------------------------------------------------------------- Toggles the step dropdown. --------------------------------------------------------------//
    renderAttachmentLibraryIcon = (attachments) => {
        let length = attachments.length
        this.toggleAttachments()
        let attachmentsList = attachments.map(attachment => {
            return <li key={`${attachment._id}`}>{attachment.path}</li>
        })
        let tooltipText = length ? <ul>
            <p className="underline">Current Attachments</p>
            {attachmentsList}
        </ul>
         : "Open Attachment Library"
        return addAttachmentIcon(length, this.state.toggleAttachments, tooltipText, false, this.state.displayAttachments) 
    }
// -------------------------------------------------------------- Determines if an attachment is a 3D model. --------------------------------------------------------------//

    isAttachmentModel=(step,index)=>{
        let attachments = step ? step.attachments: this.state.selectedStep.attachments   
        const currentAttachment = attachments[index]       
        const filename = this.state.viewingAttachment || currentAttachment ? currentAttachment.path : ""  
        if(typeof filename == "undefined" || filename == null){
            return false;
        }    
        let ext = findExtension(filename);
        let typeModel = isModel(ext)  
        return typeModel
    }
// -------------------------------------------------------------- Checks if path links exist for a step. --------------------------------------------------------------//

    checkPathListExist=(step,step_id,pathLinks)=>{
        let item = {
            id:step_id,
            path:[step._id]
        }

        for(const link of pathLinks)
        {
            if (link.id === item.id){
                return true
            }
                
        }
        return false
    }
// -------------------------------------------------------------- Creates a path link for a step. --------------------------------------------------------------//

    createPathLink=(step,randString)=>{

        let item = {
            id:randString,
            path:[step._id]
        }
        
        return item
        //this.displayArray.push(item)
        // this.setState({pathList:item})
    }
// -------------------------------------------------------------- Gets the current attachment index. --------------------------------------------------------------//

    getAttachmentIndex =()=>{
        return this.state.attachmentIndex
    }
// -------------------------------------------------------------- Checks if an annotation has been created previously. --------------------------------------------------------------//

    getAnnotationHasBeenCreatedPre = () =>{
        return this.state.annotationHasBeenCreatedPre
    }
// -------------------------------------------------------------- Gets the selected annotation. --------------------------------------------------------------//

    getSelectedAnnotation = () => {
        return this.state.selectedAnnotation
    }
// -------------------------------------------------------------- Checks if an annotation has been added. --------------------------------------------------------------//

    getAddedAnnotation=()=>{
        return this.state.addedAnnotation
    }
    // todo: maybe delete this
    getCurrentStepAttachmentModel=()=>{
        return this.state.currentStepAttachmentModel
    }
// -------------------------------------------------------------- Sets the selected text and related data for highlighting in the PDF. --------------------------------------------------------------//

    setSelectedText=(selectedText,quads,pageNumber)=>{
        this.setState({selectedText,quads,pageNumber})
    }
// -------------------------------------------------------------- Toggles the visibility of the Table of Contents (TOC). --------------------------------------------------------------//

    toggleTOC = () =>{
        this.setState(({ showTOC }) => ({ showTOC: !showTOC }));
    }
// -------------------------------------------------------------- Toggles the annotation panel. --------------------------------------------------------------//

    toggleAnnotation =(e)=>{
        e.stopPropagation();
        let toggleAnnotation = this.state.toggleAnnotation
        this.setState ({toggleAnnotation: !toggleAnnotation, editingStepAlerts:false,editingContent:false},() => this.createStepsDisplay());
    }
// -------------------------------------------------------------- Opens wi link modal selection. --------------------------------------------------------------//

    setWILinkModal=(modalState)=>{
        this.setState({addingPDFPageWILink:modalState})
    }
// -------------------------------------------------------------- Sets the attachment index and checks if the attachment is a model. --------------------------------------------------------------//
    //edited
    setAttachmentIndex=(value)=>{
        let isModel = this.isAttachmentModel(null,value);
        this.setState({attachmentIndex: value, currentStepAttachmentModel: isModel})
    }
// -------------------------------------------------------------- Sets the PDF viewer instance. --------------------------------------------------------------//

    setPdfViewerInstance =(instance,docViewer, PDFAnnotations,annoManager)=>{
        this.setState({instance,docViewer, PDFAnnotations,annoManager},()=>{this.getSetWipPDF()})
    }
// -------------------------------------------------------------- Retrieves and sets the Work in Progress (WIP) PDF. --------------------------------------------------------------//

    getSetWipPDF = async () =>{
        if(checkNotUndefindeNull(this.state.instance) && checkNotUndefindeNull(this.state.steps)) {
          await  axios.get(
                fileUrl(this.state.workInstruction.pdfPath),
                { responseType: "arraybuffer" }
              ).then(rep=>{
                    var file = new Blob([rep.data], { type: "application/pdf" });
                    var fileURL = URL.createObjectURL(file);
                    this.setState({
                        currentPDF: file,
                    });
                    this.state.instance.UI.loadDocument(fileURL,{fileName: fileName(this.state.workInstruction.preview_img || '') })
              });
        }
    }
// -------------------------------------------------------------- Sets the mapping annotations in the state. --------------------------------------------------------------//

    setMappingAnnotations=(annoList)=>{
        this.setState({annoList})
    }
// -------------------------------------------------------------- Retrieves camera information from the Unity context. --------------------------------------------------------------//

    getCameraInfo=()=>{
        if(checkNotUndefindeNull(this.state.unityContextRef)){
         this.state.unityContextRef.send("Manager","OutputCameraPositionData")
        }
    }
// -------------------------------------------------------------- Deletes a single PDF annotation. --------------------------------------------------------------//

    deleteSingleAnnotation = async (wi) => {
        console.log('[deleteSingleAnnotation] Starting deletion process')
        console.log('[deleteSingleAnnotation] Selected annotation:', this.state.selectedAnnotation)
        console.log('[deleteSingleAnnotation] WI parameter:', wi)
        console.log('[deleteSingleAnnotation] isPDFViewer:', this.state.workInstruction?.isPDFViewer)
        
        try {
            // Always delete the PDF annotation/highlight first
            console.log('[deleteSingleAnnotation] Calling deletePDFAnnotation with:', this.state.selectedAnnotation.elementName)
            await this.deletePDFAnnotation(this.state.selectedAnnotation.elementName)
            console.log('[deleteSingleAnnotation] PDF annotation deleted successfully')
        } catch (e) {
            console.error('Error deleting PDF annotation:', e)
        }
        
        // For Steps WI links (not pure PDF viewer), also call deleteWILink to handle WipGroup and step content
        // For PDF WI links, skip this because the WI link data is embedded in the annotation itself
        if (wi && !this.state.workInstruction?.isPDFViewer) {
            try {
                console.log('[deleteSingleAnnotation] Steps WI detected, calling deleteWILink with wiID:', wi)
                this.deleteWILink({ wiID: wi })
                console.log('[deleteSingleAnnotation] WI link deletion called for Steps')
            } catch (e) {
                console.error('Error deleting WI link for Steps:', e)
            }
        } else if (wi) {
            console.log('[deleteSingleAnnotation] PDF WI detected, skipping deleteWILink (data already removed with annotation)')
        }
        
        // Hard refresh from backend to ensure highlights are in sync after deletion
        try {
            console.log('[deleteSingleAnnotation] Refreshing WI data from backend')
            const res = await fetchWorkInstruction(this.props.wip_ID)
            const wiData = cloneDeep(res.data)
            console.log('[deleteSingleAnnotation] Fresh WI data PDFViewerHighlights:', wiData.PDFViewerHighlights)
            this.setState({
                workInstruction: wiData,
                PDFViewerHighlights: wiData.PDFViewerHighlights,
                annoList: wiData.PDFViewerHighlights,
            })
            console.log('[deleteSingleAnnotation] State updated with fresh data')
        } catch (e) {
            console.error('Error refreshing WI data:', e)
        }
    }
// -------------------------------------------------------------- Adds a new highlight annotation to the PDF. --------------------------------------------------------------//

    addNewHighlightAnnotation=()=>{
        const highlight = new this.state.PDFAnnotations.TextHighlightAnnotation();
        let id = this.makeid(15);
        highlight.PageNumber = this.state.pageNumber;
        highlight.X = 405;
        highlight.Y = 165;
        highlight.Width = 275;
        highlight.Height = 25;    
        highlight.StrokeColor = new this.state.PDFAnnotations.Color(255, 255, 0);
        highlight.Quads = this.state.quads
        highlight.elementName = String(highlight.Id)
        this.state.annoManager.addAnnotation(highlight);
        this.state.annoManager.drawAnnotations(highlight.PageNumber);
        let annoListClone = Array.isArray(this.state.annoList) ? [...this.state.annoList] : [];
        let item = {
            Anno_id : String(highlight.Id),
            highlight_color: "225,225,0",
            text: this.state.selectedText,
            str : this.convertQuads(), 
            quads: this.state.quads,
            pageNumber:this.state.pageNumber,
            mappingID:"", 
            pdf: this.state.pdfPath, 
            attachments: [],
            WIPID: this.state.workInstruction._id
        }
        createHighlight(item).then((data)=>{
            item._id = data.data._id;
            annoListClone.push(item)
            this.setState({annoList:annoListClone,
                currentlySelectedPDFAnnotationAttachment: item.attachments,
                currentlySelectedPDFAnnotationID: item.quads[0],
                currentAttachments: item.attachments,
                currentHighlightID: data.data._id,
                attachmentIndex: 0,
                isRedraw:false
            },()=>{this.toggleAttachments()})
        }).catch((error)=>{
            console.log(error);
        })
    }  
// -------------------------------------------------------------- Adds a new highlight wi link to the PDF. --------------------------------------------------------------//

    addNewWILinkAnnotation=(wip_ID)=>{
        const highlight = new this.state.PDFAnnotations.TextHighlightAnnotation();
        let id = this.makeid(15);
        highlight.PageNumber = this.state.pageNumber;
        highlight.X = 405;
        highlight.Y = 165;
        highlight.Width = 275;
        highlight.Height = 25;    
        highlight.StrokeColor = new this.state.PDFAnnotations.Color(144,238,144);
        highlight.Quads = this.state.quads
        highlight.elementName = String(highlight.Id) + "~~~~WILINK:" + JSON.stringify(wip_ID);
        this.state.annoManager.addAnnotation(highlight);
        this.state.annoManager.drawAnnotations(highlight.PageNumber);
        let annoListClone = this.state.annoList
        let item = {
            Anno_id : String(highlight.Id) + "~~~~WILINK:" + JSON.stringify(wip_ID),
            highlight_color: "144,238,144",
            text: this.state.selectedText,
            str : this.convertQuads(), 
            quads: this.state.quads,
            pageNumber:this.state.pageNumber,
            mappingID:"", 
            pdf: this.state.pdfPath, 
            attachments: [],
        }
        annoListClone.push(item)
        let title = this.state.selectedText
        this.setState({annoList:annoListClone,
            currentlySelectedPDFAnnotationAttachment: item.attachments,
            currentlySelectedPDFAnnotationID: item.quads[0],
            currentAttachments: item.attachments,
            attachmentIndex: 0,
            isRedraw:false
        },()=>{    
            this.addWILink(wip_ID)
        })
    } 
// -------------------------------------------------------------- Converts quads to a string format. --------------------------------------------------------------//

    convertQuads=()=>{
        return `${this.state.quads[0].x1},${this.state.quads[0].x2},${this.state.quads[0].x3},${this.state.quads[0].x3},
        ${this.state.quads[0].y1},${this.state.quads[0].y2},${this.state.quads[0].y3},${this.state.quads[0].y3}`
    }
// -------------------------------------------------------------- Checks if an annotation is to be redrawn. --------------------------------------------------------------//

    returnIsRedraw = (g)=> {
        return this.state.isRedraw;
    }

    // -------------------------------------------------------------- Highlights text based on a search string. --------------------------------------------------------------//

// -------------------------------------------------------------- Deletes a PDF annotation and updates the annotation list. --------------------------------------------------------------//

    deletePDFAnnotation=(id)=>{
        let annotations = this.state.annoList.filter(anno => id != anno.Anno_id )
        let annoToDelete = this.state.annoList.filter(anno => id == anno.Anno_id )
        deleteHighlight(annoToDelete).then((data)=>{
            this.setState({annoList:annotations},() => {this.saveWorkInstruction();this.redrawAnnotations()  })
        }).catch((error)=>{
            console.log(error)
            alert("There was an error deleteing the annotation.")
        })
    }
// -------------------------------------------------------------- Redraws PDF highlights and sets the selected annotation. --------------------------------------------------------------//

    redrawAnnotations=()=>{
        const annots = this.state.annoManager.getAnnotationsList();
        this.state.annoManager.deleteAnnotations(annots);
        let data = this.state.annoList
          if (data != null && data.length > 0){
             data.forEach(anno => {
               const highlight = new this.state.PDFAnnotations.TextHighlightAnnotation();
               highlight.PageNumber = anno.pageNumber;                
               highlight.StrokeColor = new this.state.PDFAnnotations.Color(255, 255, 0);
               highlight.Quads = anno.quads
               highlight.elementName = anno.Anno_id
               this.state.annoManager.addAnnotation(highlight);
               this.state.annoManager.drawAnnotations(highlight.PageNumber);
             });
          
          }
    }
// -------------------------------------------------------------- Sets the "isRedraw" state to true. --------------------------------------------------------------//

    setIsRedrawTrue=(annotation,quads)=>{
        this.setState({isRedraw:true},()=>this.setSelectedAnnotationPDF(annotation,quads))
    }
// -------------------------------------------------------------- Sets the selected PDF annotation and related data. --------------------------------------------------------------//

    setSelectedAnnotationPDF=(annotation,quads)=>{
        const annots = this.state.annoManager.getAnnotationsList();
        this.state.annoManager.deleteAnnotations(annots);
        
        this.state.annoList.forEach(anno=>{
            if (this.isHighlightTheSame(quads,anno.quads[0])){
                this.redrawHighlights(true,anno)
                this.setState({
                    selectedAnnotation:annotation,
                    currentlySelectedPDFAnnotationAttachment: anno.attachments,
                    currentlySelectedPDFAnnotationID: anno.quads[0],
                    currentAttachments: anno.attachments,
                    currentHighlightID: anno._id,
                    attachmentIndex: 0,
                    isRedraw:false
                })
            }
            else{
                this.redrawHighlights(false,anno)
            }
        })
    }
// -------------------------------------------------------------- Redraws PDF highlights, marking the selected annotation as selected. --------------------------------------------------------------//

    redrawHighlights =(isSelected,anno)=>{
        const highlight = new this.state.PDFAnnotations.TextHighlightAnnotation();
        highlight.PageNumber = anno.pageNumber;  
        if(isSelected){
          highlight.StrokeColor = new this.state.PDFAnnotations.Color(173,216,230);
        }else{
            if(anno.highlight_color == "144,238,144"){
                highlight.StrokeColor = new this.state.PDFAnnotations.Color(144,238,144); 
            }
            else{
                highlight.StrokeColor = new this.state.PDFAnnotations.Color(255, 255, 0);  
            }
        }                      
        highlight.Quads = anno.quads
        highlight.elementName = anno.Anno_id
        this.state.annoManager.addAnnotation(highlight);
        this.state.annoManager.drawAnnotations(highlight.PageNumber);
    }
// -------------------------------------------------------------- Updates the annotation list in the state. --------------------------------------------------------------//

    updateAnnoList=(list)=>{
      this.setState({annoList:list})
    }

    render = () => {     
        let attachments = this.state.currentAttachments
        if(this.state.isPDFViewer === 0){
            attachments = []
        }
        return <div >
            {this.renderModal()}
             <div id="success-banner" className="flex-centered fade-in-and-out max-width"
                style={{ display: `${this.state.confirmationMessage.length > 0 ? "flex" : "none"}` }}
                //  onClick={this.closeConfirmation}
                 >
                <p>{this.state.confirmationMessage}</p>
            </div>
            {/* Editing Warning Modal */}
            {this.state.showEditingWarningModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        maxWidth: '500px',
                        width: '90%',
                        textAlign: 'center'
                    }}>
                        <h3 style={{
                            color: '#333',
                            marginBottom: '15px',
                            fontSize: '20px'
                        }}>
                            Work Instruction In Use
                        </h3>
                        <p style={{
                            color: '#666',
                            marginBottom: '25px',
                            lineHeight: '1.5',
                            fontSize: '16px'
                        }}>
                            {this.state.editingWarningMessage}
                        </p>
                        <div style={{
                            display: 'flex',
                            gap: '15px',
                            justifyContent: 'center'
                        }}>
                            <button
                                onClick={this.handleReturnToList}
                                style={{
                                    backgroundColor: '#95a5a6',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 24px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: 'bold'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#7f8c8d'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#95a5a6'}
                            >
                                Return to List
                            </button>
                            <button
                                onClick={this.handleContinueEditing}
                                style={{
                                    backgroundColor: '#081f5f',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 24px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: 'bold'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#0a2463'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#081f5f'}
                            >
                                Continue Anyway
                            </button>
                        </div>
                    </div>
                </div>
            )} 
            <div  className="flex">
                <div id="LeftRightAuthorContainer">
                    <div id="wi-author-right" className="flex-row max-size">
                        <div id="attachments-display-container" className="flex-column max-width">
                            {attachments.length > 0 ?
                                <AttachmentRenderer
                                    attachments={this.state.currentAttachments}
                                    setAttachmentIndex={(value) => this.setAttachmentIndex(value)}
                                    attachmentIndex={this.state.attachmentIndex}
                                    updateColor={this.storeColor}
                                    WIPID = {this.state.workInstruction._id}
                                    storeCameraData={this.storeCameraData}
                                    openAttachments={() => this.setState({ showingAttachments: true })}
                                    updateCurrentCameraPlacement = {this.updateCurrentCameraPlacement}
                                    toggleAnnotation={this.state.toggleAnnotation}
                                    unityContextRef = {this.state.unityContextRef}
                                    updateUnityContext = {this.updateUnityContext}
                                    callFromAuthor = {true}
                                    textSelectedInEditorFlag={this.state.textSelectedInEditorFlag}
                                    textSelectedInEditor={this.state.textSelectedInEditor}
                                    isPDFViewer={this.state.isPDFViewer}
                                    currentlySelectedPDFAnnotationID={this.state.currentlySelectedPDFAnnotationID}
                                    libraryOpen={this.state.showingAttachments}
                                    />
                                :
                                <Directions openAttachments={this.props.openAttachments} />}
                        </div>
                        <div >
                        
                        </div>
                    </div>
                     <div id="wi-author-left" className="flex max-height"> 
                     {this.state.isPDFViewer?
                     <div style={{width:"100%",height:"100%",display:"flex",flexDirection:"column",overflow:"hidden" }}>   
                        {!this.props.isLiteView && (
                            <Toolbar
                                WITitle={this.state.title}
                                toggleEditTags={this.toggleEditTags}
                                isPDFWip={true}
                                currentWorkInstructionTags={cloneDeep(this.props.workInstruction.tags)}
                                isSavable={this.state.isSavable}
                                saveWorkInstruction={this.saveWorkInstruction}
                                previewWorkInstruction={this.previewWorkInstruction}
                                editPublicationPage={this.editPublicationPage}
                                isReleased={this.state.isReleased}
                                toggleAllAlertsPage={this.toggleAllAlertsPage}
                                toggleRelease={this.toggleRelease}
                                togglePublicationPage={this.togglePublicationPage}
                            />
                        )}

                        <div style={{flex:"1",minHeight:0,overflow:"hidden"}}>
                            <PDFDisplay
                            isLiteView={this.state.isLiteView}
                            setSelectedText={this.setSelectedText}
                            setPdfViewerInstance={this.setPdfViewerInstance}
                            textToSearch={this.state.textToSearch}
                            currentPDF={this.state.currentPDF}
                            setMappingAnnotations={this.setMappingAnnotations}
                            getCameraInfo={this.getCameraInfo}
                            unityContextRef={this.state.unityContextRef}
                            addNewHighlightAnnotation={this.addNewHighlightAnnotation} 
                            PDFViewerHighlights={this.state.PDFViewerHighlights}
                            deletePDFAnnotation={this.deletePDFAnnotation}
                            toggleAttachments = {this.toggleAttachments}
                            setSelectedAnnotation={this.setIsRedrawTrue}
                            updateAnnoList={this.updateAnnoList}
                            isRedraw={this.returnIsRedraw}
                            deleteSingleAnnotation={this.deleteSingleAnnotation}
                            setWILinkModal={this.setWILinkModal}
                            openNewTab={this.props.addTab}
                            />
                        </div>
                       
                     </div>
                                          
                     :
                      <Fragment> <div id={`${this.state.showTOC? 'steps-display-container-half':'steps-display-container-full'}`}>
                          <div style={{width:'100%', height:"100%", overflowY:"hidden", overflowX:"hidden"}}>
                           
                   

{/* ---------------------------------------------------------------- DISPLAYS STEPS AND EDITOR  (LEFT SIDE) ---------------------------------------------------------------- */}

                            <div id="step-Div-Parent" style={{width:'100%', height:"calc(100% - 50px)", overflowY:"scroll", overflowX:"hidden"}}  >
                                <ul>{this.state.stepsDisplay}</ul>
                            </div>
                        </div>
                        </div>
{/* ---------------------------------------------------------------- DISPLAYS STEP TREE (RIGHT SIDE) ---------------------------------------------------------------- */}

                        {this.state.loaded && this.state.showTOC ?
                            <TableOfContents
                                getSteps={()=> {return this.state.steps}}
                                getPath={()=>{return this.state.path}}
                                WIPID={this.props.wip_ID}
                                steps={this.state.steps}
                                stepDeleted={this.stepDeleted}
                                selectStep={this.selectStep}
                                editTitle={() => this.setState({ editingStepTitle: true })}
                                toggleAllAlertsPage={this.toggleAllAlertsPage}
                                selectedStepId={this.state.selectedStep ? this.state.selectedStep._id : 0}
                                tree={this.state.tree}
                                path={this.state.path}
                                selectedStep={this.state.selectedStep}
                                addStep={this.addStep}
                                updateTree={this.updateTree}
                                updateSteps={this.updateSteps}
                                UpdateStepNodePath={(list) => this.setState({stepNodePath: list})}
                                combinedTitle={this.state.combinedTitle}
                                toolbar={
                                    <Toolbar
                                        WITitle={this.state.title}
                                        toggleEditTags={this.toggleEditTags}
                                        // toggleAutoSave={this.toggleAutoSave}
                                        // hasAutoSave={this.state.hasAutoSave}
                                        isPDFWip={false}
                                        currentWorkInstructionTags={cloneDeep(this.props.workInstruction.tags)}
                                        // submitTitleEdit={(title) => this.setState({ title, isSavable: true })}
                                        isSavable={this.state.isSavable}
                                        saveWorkInstruction={this.saveWorkInstruction}
                                        previewWorkInstruction={this.previewWorkInstruction}
                                        editPublicationPage={this.editPublicationPage}
                                        isReleased={this.state.isReleased}
                                        toggleAllAlertsPage={this.toggleAllAlertsPage}
                                        toggleRelease={this.toggleRelease}
                                        togglePublicationPage={this.togglePublicationPage}
                                    />}
                            /> 
                            :null
                        } 
                       </Fragment> } 
                    </div>
                    
                </div>
            </div>
        </div>
    }
}

export default withRouter(WIAuthorPDF)